







































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import TabChange from './tabChange.vue'
import Empty from '@/components/Empty/index.vue'
import {
  getOrderDetailPage,
  queryOrderDetailById,
  completeOrder,
  deliveryOrder,
  orderCancel,
  orderReject,
  orderAccept,
  getOrderListBy,
} from '@/api/order'
import printer from '@/utils/bluetoothPrinter'
import {
  buildOrderReceipt,
  buildTestReceipt,
  RECEIPT_COLUMNS_80MM,
} from '@/utils/receiptTemplate'
import {
  submitPrintJob,
  getPrintAgentStatus,
  getPrintJobStatus,
} from '@/api/print'
import { uint8ToBase64, waitPrintJobDone } from '@/utils/printBytes'

const AUTO_PRINT_KEY = 'skyPrinterAutoPrint'
const PREFER_NETWORK_KEY = 'skyPrinterPreferNetwork'
const NETWORK_SHOP_KEY =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.VUE_APP_PRINT_SHOP_KEY) ||
  'default'

@Component({
  components: {
    HeadLable,
    InputAutoComplete,
    TabChange,
    Empty,
  },
})
export default class extends Vue {
  private defaultActivity: any = 0
  private orderStatics = {}
  private row = {}
  private isAutoNext = true
  private isTableOperateBtn = true
  private currentPageIndex = 0 //记录查看详情数据的index
  private orderId = '' //订单号
  private input = '' //搜索条件的订单号
  private phone = '' //搜索条件的手机号
  /** 筛选取餐方式：'' 全部；1 外送 2 自提 3 堂食 */
  private filterOrderType: number | '' = ''
  private valueTime = []
  private dialogVisible = false //详情弹窗
  private cancelDialogVisible = false //取消，拒单弹窗
  private cancelDialogTitle = '' //取消，拒绝弹窗标题
  private cancelReason = ''
  private remark = '' //自定义原因
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData = []
  private diaForm = []
  private isSearch: boolean = false
  private orderStatus = 0 //列表字段展示所需订单状态,用于分页请求数据
  private dialogOrderStatus = 0 //弹窗所需订单状态，用于详情展示字段
  private printerSupported: boolean = printer.isSupported
  private printerConnected: boolean = false
  private printerDeviceName: string = ''
  private autoPrintOnAccept: boolean = localStorage.getItem(AUTO_PRINT_KEY) !== 'false'
  private preferNetworkPrint: boolean =
    localStorage.getItem(PREFER_NETWORK_KEY) === 'true'
  private agentOnline: boolean = false
  private agentPollTimer: ReturnType<typeof setInterval> | null = null
  private unbindPrinterListener: (() => void) | null = null
  private cancelOrderReasonList = [
    {
      value: 1,
      label: '订单量较多，暂时无法接单',
    },
    {
      value: 2,
      label: '菜品已销售完，暂时无法接单',
    },
    {
      value: 3,
      label: '餐厅已打烊，暂时无法接单',
    },
    {
      value: 0,
      label: '自定义原因',
    },
  ]

  private cancelrReasonList = [
    {
      value: 1,
      label: '订单量较多，暂时无法接单',
    },
    {
      value: 2,
      label: '菜品已销售完，暂时无法接单',
    },
    {
      value: 3,
      label: '骑手不足无法配送',
    },
    {
      value: 4,
      label: '客户电话取消',
    },
    {
      value: 0,
      label: '自定义原因',
    },
  ]
  private orderList = [
    {
      label: '全部订单',
      value: 0,
    },
    {
      label: '待付款',
      value: 1,
    },
    {
      label: '待接单',
      value: 2,
    },
    {
      label: '待派送',
      value: 3,
    },
    {
      label: '派送中',
      value: 4,
    },
    {
      label: '已完成',
      value: 5,
    },
    {
      label: '已取消',
      value: 6,
    },
  ]

  /** 明细 amount 为单价，行金额 = amount × number */
  orderDetailLineTotal(item: any) {
    const unit = Number(item && item.amount) || 0
    const qty = Number(item && item.number) || 1
    if (!unit && !qty) return ''
    return (Math.round(unit * qty * 100) / 100).toFixed(2)
  }

  get dishTotalAmount() {
    const list = (this.diaForm && (this.diaForm as any).orderDetailList) || []
    const totalCents = list.reduce((sum: number, item: any) => {
      const unit = Number(item && item.amount) || 0
      const qty = Number(item && item.number) || 1
      return sum + Math.round(unit * qty * 100)
    }, 0)
    return (totalCents / 100).toFixed(2)
  }

  created() {
    this.init(Number(this.$route.query.status) || 0)
    if (this.printerSupported) {
      this.unbindPrinterListener = printer.onChange(({ connected, deviceName }) => {
        this.printerConnected = connected
        this.printerDeviceName = deviceName || ''
      })
      printer.reconnect().catch(() => {})
    }
    this.refreshAgentStatus().catch(() => {})
    this.setupAgentPoll()
  }

  mounted() {
    //如果有值说明是消息通知点击进来的
    if (
      this.$route.query.orderId &&
      this.$route.query.orderId !== 'undefined'
    ) {
      this.goDetail(this.$route.query.orderId, 2)
    }
    if (this.$route.query.status) {
      this.defaultActivity = this.$route.query.status
    }
    // console.log(this.$route.query, 'this.$route')
  }

  beforeDestroy() {
    if (this.unbindPrinterListener) this.unbindPrinterListener()
    if (this.agentPollTimer) {
      clearInterval(this.agentPollTimer)
      this.agentPollTimer = null
    }
  }

  @Watch('autoPrintOnAccept')
  onAutoPrintChanged(val: boolean) {
    try {
      localStorage.setItem(AUTO_PRINT_KEY, val ? 'true' : 'false')
    } catch (e) {
      /* ignore */
    }
  }

  @Watch('preferNetworkPrint')
  onPreferNetworkPrintChanged(val: boolean) {
    try {
      localStorage.setItem(PREFER_NETWORK_KEY, val ? 'true' : 'false')
    } catch (e) {
      /* ignore */
    }
    this.setupAgentPoll()
    if (val) this.refreshAgentStatus().catch(() => {})
  }

  async handleConnectPrinter() {
    try {
      await printer.connect()
      this.$message.success('打印机已连接')
    } catch (err) {
      if (err && err.name === 'NotFoundError') return
      this.$message.error('连接失败：' + (err && err.message ? err.message : err))
    }
  }

  async handleDisconnectPrinter() {
    await printer.disconnect(true)
    this.$message.success('已断开打印机')
  }

  async handleTestPrint() {
    try {
      const bytes = buildTestReceipt()
      await printer.write(bytes)
      this.$message.success('测试打印已发送')
    } catch (err) {
      this.$message.error('打印失败：' + (err && err.message ? err.message : err))
    }
  }

  private receiptOptions80() {
    return { columns: RECEIPT_COLUMNS_80MM }
  }

  async refreshAgentStatus() {
    const res: any = await getPrintAgentStatus(NETWORK_SHOP_KEY)
    const vo = res && res.data && res.data.data
    this.agentOnline = !!(vo && vo.online)
  }

  setupAgentPoll() {
    if (this.agentPollTimer) {
      clearInterval(this.agentPollTimer)
      this.agentPollTimer = null
    }
    if (!this.preferNetworkPrint) return
    this.agentPollTimer = setInterval(() => {
      this.refreshAgentStatus().catch(() => {})
    }, 12000)
  }

  async handleTestNetworkPrint() {
    try {
      const bytes = buildTestReceipt(this.receiptOptions80())
      const res: any = await submitPrintJob({
        payloadBase64: uint8ToBase64(bytes),
        shopKey: NETWORK_SHOP_KEY,
        orderNumber: 'TEST',
      })
      if (res.data.code !== 1) {
        this.$message.error(res.data.msg || '提交失败')
        return
      }
      const vo = res.data.data
      if (vo.queued) {
        this.$message.success('测试任务已排队，Agent 在线后将出票')
        return
      }
      const final = await waitPrintJobDone(async () => {
        const st: any = await getPrintJobStatus(vo.jobId)
        const d = st.data.data
        return { status: d.status, errorMessage: d.errorMessage }
      })
      if (final.status === 'DONE') this.$message.success('网口测试打印完成')
      else if (final.status === 'FAILED') {
        this.$message.error('网口测试失败：' + (final.errorMessage || ''))
      } else this.$message.success('已下发至门店 Agent')
    } catch (err) {
      this.$message.error(
        '网口测试失败：' + (err && (err as any).message ? (err as any).message : err)
      )
    }
  }

  async printReceiptViaNetwork(order: any): Promise<void> {
    if (!order) return
    try {
      const bytes = buildOrderReceipt(order, this.receiptOptions80())
      const res: any = await submitPrintJob({
        payloadBase64: uint8ToBase64(bytes),
        shopKey: NETWORK_SHOP_KEY,
        orderNumber: order.number != null ? String(order.number) : undefined,
      })
      if (res.data.code !== 1) {
        this.$message.warning('网口打印提交失败：' + (res.data.msg || ''))
        return
      }
      const vo = res.data.data
      if (vo.queued) {
        this.$message.success('已加入打印队列，门店 Agent 在线后将出票')
        return
      }
      const final = await waitPrintJobDone(async () => {
        const st: any = await getPrintJobStatus(vo.jobId)
        const d = st.data.data
        return { status: d.status, errorMessage: d.errorMessage }
      })
      if (final.status === 'DONE') this.$message.success('网口打印完成')
      else if (final.status === 'FAILED') {
        this.$message.error('网口打印失败：' + (final.errorMessage || ''))
      } else this.$message.success('已下发至门店 Agent')
    } catch (err) {
      this.$message.warning(
        '网口打印失败：' + (err && (err as any).message ? (err as any).message : err)
      )
    }
  }

  async printReceipt(order: any): Promise<void> {
    if (this.preferNetworkPrint) {
      return this.printReceiptViaNetwork(order)
    }
    if (!this.printerSupported) return
    if (!order) return
    try {
      const bytes = buildOrderReceipt(order)
      await printer.write(bytes)
    } catch (err) {
      this.$message.warning('打印失败：' + (err && err.message ? err.message : err))
    }
  }

  async handleReprint() {
    if (!this.printerSupported && !this.preferNetworkPrint) {
      this.$message.warning('请勾选「使用网口打印」或使用支持蓝牙的 Chrome/Edge')
      return
    }
    if (!this.diaForm) {
      this.$message.warning('订单数据未加载')
      return
    }
    try {
      if (this.preferNetworkPrint) {
        await this.printReceiptViaNetwork(this.diaForm as any)
      } else {
        const bytes = buildOrderReceipt(this.diaForm as any)
        await printer.write(bytes)
        this.$message.success('小票已发送至蓝牙打印机')
      }
    } catch (err) {
      this.$message.error('打印失败：' + (err && err.message ? err.message : err))
    }
  }

  initFun(orderStatus) {
    this.page = 1
    this.init(orderStatus)
  }

  change(activeIndex) {
    if (activeIndex === this.orderStatus) return
    this.init(activeIndex)
    this.input = ''
    this.phone = ''
    this.filterOrderType = ''
    this.valueTime = []
    this.dialogOrderStatus = 0
    this.$router.push('/order')
    console.log(activeIndex, '接收到了子组件的index')
  }

  //获取待处理，待派送，派送中数量
  getOrderListBy3Status() {
    getOrderListBy({})
      .then((res) => {
        if (res.data.code === 1) {
          this.orderStatics = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  init(activeIndex: number = 0, isSearch?) {
    this.isSearch = isSearch
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      number: this.input || undefined,
      phone: this.phone || undefined,
      beginTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[0]
          : undefined,
      endTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[1]
          : undefined,
      status: activeIndex || undefined,
      orderType:
        this.filterOrderType === '' ||
        this.filterOrderType === undefined ||
        this.filterOrderType === null
          ? undefined
          : Number(this.filterOrderType),
    }
    getOrderDetailPage({ ...params })
      .then((res) => {
        if (res.data.code === 1) {
          this.tableData = res.data.data.records
          this.orderStatus = activeIndex
          this.counts = Number(res.data.data.total)
          this.getOrderListBy3Status()
          if (
            this.dialogOrderStatus === 2 &&
            this.orderStatus === 2 &&
            this.isAutoNext &&
            !this.isTableOperateBtn &&
            res.data.data.records.length > 1
          ) {
            const row = res.data.data.records[0]
            this.goDetail(row.id, row.status, row)
          } else {
            return null
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  /** 列表空数据时与地址列一致显示「—」 */
  cellOrDash(val: any) {
    if (val === null || val === undefined) return '—'
    const s = String(val).trim()
    return s.length ? s : '—'
  }

  /** 自提(2)、堂食(3)，仅用于接单后是否走补完成流程 */
  isPickupOrDineOrderType(orderType: number | string | undefined | null) {
    const n = Number(orderType)
    return n === 2 || n === 3
  }

  /** ElTag type：外送 danger / 自提 warning / 堂食 success / 其它 info */
  pickupTagType(orderType: number | string | undefined | null) {
    const n = Number(orderType)
    if (n === 1) return 'danger'
    if (n === 2) return 'warning'
    if (n === 3) return 'success'
    return 'info'
  }

  /** orderType：1 外送 2 自提 3 堂食 */
  formatPickupType(orderType: number | string | undefined | null) {
    const n = Number(orderType)
    if (n === 1) return '外送'
    if (n === 2) return '自提'
    if (n === 3) return '堂食'
    if (orderType === '' || orderType === undefined || orderType === null) {
      return '—'
    }
    return String(orderType)
  }

  getOrderType(row: any) {
    if (row.status === 1) {
      return '待付款'
    } else if (row.status === 2) {
      return '待接单'
    } else if (row.status === 3) {
      return '待派送'
    } else if (row.status === 4) {
      return '派送中'
    } else if (row.status === 5) {
      return '已完成'
    } else if (row.status === 6) {
      return '已取消'
    } else {
      return '退款'
    }
  }

  // 查看详情
  async goDetail(id: any, status: number, row?: any) {
    // console.log(111, index, row)
    this.diaForm = []
    this.dialogVisible = true
    this.dialogOrderStatus = status
    this.orderId = id
    const { data } = await queryOrderDetailById({ orderId: id })
    this.diaForm = data.data
    this.row = row || { id: this.$route.query.orderId, status: status }
    if (this.$route.query.orderId) {
      this.$router.push('/order')
    }
  }

  //打开拒单弹窗
  orderReject(row: any) {
    this.cancelDialogVisible = true
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    this.cancelDialogTitle = '拒绝'
    this.dialogVisible = false
    this.cancelReason = ''
  }

  /** 自提、堂食接单后跳过派送：必要时补调完成接口（后端若在 confirm 已置为已完成则跳过） */
  private async completeAfterAcceptIfPickupOrDineIn(row: any): Promise<boolean> {
    if (!this.isPickupOrDineOrderType(row.orderType)) return true
    let st: number | undefined
    try {
      const dr = await queryOrderDetailById({ orderId: row.id })
      st = Number(dr && dr.data && dr.data.data && dr.data.data.status)
    } catch (e) {
      /* 详情失败仍尝试完成 */
    }
    if (st === 5 || st === 6) return true
    try {
      const comp = await completeOrder({ id: row.id })
      if (comp.data.code === 1) return true
      let stAfter: number | undefined
      try {
        const dr2 = await queryOrderDetailById({ orderId: row.id })
        stAfter = Number(dr2 && dr2.data && dr2.data.data && dr2.data.data.status)
      } catch (e) {
        /* ignore */
      }
      if (stAfter === 5) return true
      this.$message.error(
        comp.data.msg || '接单成功，自动完成失败，请在列表中手动完成订单'
      )
      return false
    } catch (err) {
      this.$message.error(
        '接单成功，完成订单请求失败：' +
          (err && err.message ? err.message : String(err))
      )
      return false
    }
  }

  //接单
  async orderAccept(row: any) {
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    try {
      const res = await orderAccept({
        id: this.orderId,
        orderType: row.orderType,
      })
      if (res.data.code === 1) {
        const okDone = await this.completeAfterAcceptIfPickupOrDineIn(row)
        if (!okDone) {
          this.orderId = ''
          this.dialogVisible = false
          this.init(this.orderStatus)
          return
        }
        this.$message.success('操作成功')
        if (this.autoPrintOnAccept && (this.printerSupported || this.preferNetworkPrint)) {
          let orderData: any = this.diaForm
          const hasDetails =
            orderData && (orderData as any).orderDetailList && (orderData as any).number
          if (!hasDetails) {
            try {
              const { data } = await queryOrderDetailById({ orderId: row.id })
              orderData = data && data.data
            } catch (e) {
              /* 拉取详情失败不影响接单流程 */
            }
          }
          if (orderData) this.printReceipt(orderData)
        }
        this.orderId = ''
        this.dialogVisible = false
        this.init(this.orderStatus)
      } else {
        this.$message.error(res.data.msg)
      }
    } catch (err) {
      this.$message.error('请求出错了：' + (err && err.message ? err.message : err))
    }
  }

  //打开取消订单弹窗
  cancelOrder(row: any) {
    this.cancelDialogVisible = true
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    this.cancelDialogTitle = '取消'
    this.dialogVisible = false
    this.cancelReason = ''
  }

  //确认取消或拒绝订单并填写原因
  confirmCancel(type) {
    if (!this.cancelReason) {
      return this.$message.error(`请选择${this.cancelDialogTitle}原因`)
    } else if (this.cancelReason === '自定义原因' && !this.remark) {
      return this.$message.error(`请输入${this.cancelDialogTitle}原因`)
    }

    (this.cancelDialogTitle === '取消' ? orderCancel : orderReject)({
      id: this.orderId,
      // eslint-disable-next-line standard/computed-property-even-spacing
      [this.cancelDialogTitle === '取消' ? 'cancelReason' : 'rejectionReason']:
        this.cancelReason === '自定义原因' ? this.remark : this.cancelReason,
    })
      .then((res) => {
        if (res.data.code === 1) {
          this.$message.success('操作成功')
          this.cancelDialogVisible = false
          this.orderId = ''
          // this.dialogOrderStatus = 0
          this.init(this.orderStatus)
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 派送，完成
  cancelOrDeliveryOrComplete(status: number, id: string) {
    const params = {
      status,
      id,
    }
    ;(status === 3 ? deliveryOrder : completeOrder)(params)
      .then((res) => {
        if (res.data.code === 1) {
          this.$message.success('操作成功')
          this.orderId = ''
          // this.dialogOrderStatus = 0
          this.dialogVisible = false
          this.init(this.orderStatus)
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  handleClose() {
    this.dialogVisible = false
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init(this.orderStatus)
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init(this.orderStatus)
  }
}
